import { render, staticRenderFns } from "./EditWarning.vue?vue&type=template&id=f3bf680c&scoped=true&"
import script from "./EditWarning.vue?vue&type=script&lang=js&"
export * from "./EditWarning.vue?vue&type=script&lang=js&"
import style0 from "./EditWarning.vue?vue&type=style&index=0&id=f3bf680c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3bf680c",
  null
  
)

export default component.exports